module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("deposit_failed").tTitle()))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_c('i18n', {
    attrs: {
      "tag": "label",
      "place": "here"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("you_can_try").tTitle()) + "\n      "), _c('router-link', {
    attrs: {
      "to": '/' + _vm.Language + '/finance'
    }
  }, [_vm._v(_vm._s(_vm.$t("here").tTitle()))])], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v(_vm._s((_vm.reason) ? 'Reason: ' + _vm.reason : ''))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-705aa863"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/finance/deposit-return/Failed.vue
// module id = 783
// module chunks = 0